import api from '../httpClient';

export type PerformanceUnit = 'ms' | 'score';
type MetricDimensions = {
  route: string;
  endpoint: string;
  kind: string;
  name: string;
  device: string;
};

export type PerformanceGroup = MetricDimensions & {
  count: number;
  avg_ms: number;
  p50_ms: number | null;
  p95_ms: number | null;
  unit: PerformanceUnit;
  server_avg_ms: number | null;
  transfer_avg_ms: number | null;
};

export type PerformanceReport = {
  days: number;
  effective_days: number;
  scope: 'account_details' | 'all_accounts';
  truncated?: boolean;
  detail_retention_days: number;
  summary_retention_days: number;
  groups: PerformanceGroup[];
  recent: Array<MetricDimensions & {
    id: number;
    user_id: number | null;
    username: string | null;
    created_at: string;
    value: number;
    server_ms: number | null;
    ttfb_ms: number | null;
    transfer_ms: number | null;
  }>;
  daily: Array<MetricDimensions & {
    date: string;
    count: number;
    avg_ms: number;
    unit: PerformanceUnit;
  }>;
};

export type PerformanceFilters = {
  days: number;
  user_id?: number;
  route?: string;
};

export const adminPerformance = {
  get: (params: PerformanceFilters) => api.get<PerformanceReport>('/api/admin/performance/', { params }),
};
